/* Browser-local favorites; prices and variant identity always come from Shopify. */
(() => {
  const key = 'sn-shopify-wishlist-v1';
  function parseWishlist(raw) {
    const entries = JSON.parse(raw || '[]');
    if (!Array.isArray(entries) || entries.some(x => !x || typeof x.handle !== 'string' || !/^[a-z0-9-]+$/.test(x.handle) || typeof x.variantId !== 'string' || !/^[1-9][0-9]*$/.test(x.variantId))) throw Error('Invalid wishlist storage');
    if (new Set(entries.map(x=>x.variantId)).size !== entries.length) throw Error('Duplicate wishlist variants');
    return entries.map(({handle,variantId})=>({handle,variantId}));
  }
  function toggleWishlist(storage, item) {
    const entries = parseWishlist(storage.getItem(key));
    const next = entries.some(x=>x.variantId===item.variantId) ? entries.filter(x=>x.variantId!==item.variantId) : [...entries,item];
    const encoded = JSON.stringify(next);
    parseWishlist(encoded);
    storage.setItem(key, encoded);
    return next;
  }
  window.SnWishlist = (root, on, disposals, signal) => {
    const grid = root.querySelector('[data-sn-wishlist-grid]');
    if (!grid && !root.querySelector('[data-sn-wish]') && !root.matches('[data-sn-catalog]')) return;
    const status = document.createElement('p');
    status.className = 'sn-wishlist-status'; status.setAttribute('role','status'); status.hidden=true;
    root.append(status);
    const retry = document.createElement('button'); retry.type='button'; retry.className='btn'; retry.textContent='Try again'; retry.hidden=true;
    status.after(retry);
    const cache = new Map();
    const inflight = new Set();
    const prefix=(window.Shopify?.routes?.root || document.body.dataset.snRoot || '/').replace(/\/?$/,'/');
    let generation = 0;
    const read = () => parseWishlist(localStorage.getItem(key));
    const failure = () => {status.textContent='Your browser could not read or save your wishlist. Allow site storage, then try again.'; status.hidden=false; retry.hidden=false;};
    const node = (tag, text, className) => {const e=document.createElement(tag);if(text!==undefined)e.textContent=text;if(className)e.className=className;return e;};
    const button = item => {const e=node('button','♥','us-wish');e.type='button';e.dataset.snWish='';e.dataset.handle=item.handle;e.dataset.variantId=item.variantId;e.setAttribute('aria-pressed','true');e.setAttribute('aria-label','Remove from Wishlist');return e;};
    const sync = entries => root.querySelectorAll('[data-sn-wish]').forEach(b=>{
      const saved=entries.some(x=>x.variantId===b.dataset.variantId);b.disabled=false;b.setAttribute('aria-pressed',String(saved));b.setAttribute('aria-label',saved?'Remove from Wishlist':'Add to Wishlist');
      if(b.classList.contains('us-wish'))b.textContent=saved?'♥':'♡';else b.querySelector('i')?.classList.toggle('us-saved',saved);
    });
    const product = handle => {
      if (!cache.has(handle)) {
        const url=new URL(prefix+'products/'+encodeURIComponent(handle)+'.js',location.origin);
        if(url.origin!==location.origin)throw Error('Invalid product origin');
        const request=(async()=>{
          while(inflight.size>=4)await Promise.race(inflight);
          if(signal.aborted)throw Error('Section unloaded');
          const job=fetch(url,{signal,credentials:'same-origin'}).then(r=>{if(!r.ok)throw Error('Product unavailable');return r.json();});
          const settled=job.then(()=>{},()=>{});inflight.add(settled);
          try{return await job;}finally{inflight.delete(settled);}
        })().catch(e=>{cache.delete(handle);throw e;});
        cache.set(handle,request);
      }
      return cache.get(handle);
    };
    const render = async () => {
      const version=++generation;
      let entries;
      try {entries=read();sync(entries);status.textContent='';status.hidden=true;retry.hidden=true;} catch {failure();return;}
      if(!grid)return;
      grid.replaceChildren();
      if(!entries.length){grid.textContent='Your wishlist is empty. Save a product to find it here.';return;}
      const cards=entries.map(item=>{const card=node('article',undefined,'us-product-card');card.append(node('p','Loading product…'),button(item));grid.append(card);return card;});
      let index=0;
      await Promise.all(Array.from({length:Math.min(4,entries.length)},async()=>{
        while(index<entries.length && !signal.aborted && version===generation){
          const i=index++,item=entries[i],card=cards[i];
          try {
            const p=await product(item.handle);
            if(signal.aborted || version!==generation)return;
            const v=p.variants?.find(x=>String(x.id)===item.variantId);
            if(!v || !Number.isFinite(v.price))throw Error('Variant unavailable');
            const href=prefix+'products/'+encodeURIComponent(item.handle)+'?variant='+encodeURIComponent(item.variantId);
            const link=node('a');link.href=href;
            const image=v.featured_image?.src || p.featured_image;
            if(image){const u=new URL(image,location.origin);if(u.protocol==='https:'){const img=node('img');img.src=u.href;img.alt=p.title;img.loading='lazy';link.append(img);}}
            link.append(node('h2',p.title+(v.title&&v.title!=='Default Title'?' — '+v.title:'')));
            const money=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:document.body.dataset.snCurrency});
            const actions=node('div',undefined,'us-card-actions'),details=node('a','See details','btn btn-primary');details.href=href;actions.append(details,button(item));
            card.replaceChildren(link,node('p','Model: '+(v.sku||item.handle)),node('strong',money.format(v.price/100)),actions);
          } catch {
            if(signal.aborted || version!==generation)return;
            const again=node('button','Try again','btn');again.type='button';on(again,'click',()=>{cache.delete(item.handle);render();});
            card.replaceChildren(node('p','This saved product is currently unavailable.'),button(item),again);
          }
        }
      }));
    };
    on(root,'click',event=>{
      const b=event.target.closest('[data-sn-wish]');if(!b)return;event.preventDefault();
      try {toggleWishlist(localStorage,{handle:b.dataset.handle,variantId:b.dataset.variantId});document.dispatchEvent(new Event('sn:wishlist-change'));}catch{failure();}
    });
    on(document,'sn:wishlist-change',render);
    on(window,'storage',event=>{if(event.key===key||event.key===null)render();});
    on(retry,'click',render);
    disposals.push(()=>{generation++;cache.clear();status.remove();retry.remove();});
    render();
  };
})();
